<ul class="color-picker">
	<li *ngFor="let color of colors" (click)="select(color)">
		<dot [color]="color" [checked]="isSelected(color)"></dot>
	</li>
</ul>
